var map = {
	"./baby-bottle.png": 7090,
	"./bananas.png": 3443,
	"./basketball.png": 3873,
	"./bbq.png": 3010,
	"./beachball.png": 6706,
	"./bike.png": 6313,
	"./binoculars.png": 7050,
	"./bogroll.png": 9344,
	"./book.png": 5415,
	"./books.png": 8192,
	"./bucket-spade.png": 5023,
	"./cactus.png": 6166,
	"./camping-table.png": 3676,
	"./cat.png": 2693,
	"./chair.png": 6828,
	"./computer.png": 1259,
	"./controller.png": 4877,
	"./cool-box.png": 3439,
	"./cozy-coupe.png": 448,
	"./cricket-ball.png": 5641,
	"./cricket-bat.png": 334,
	"./dice.png": 7577,
	"./drinks.png": 7367,
	"./flip-flops.png": 4466,
	"./football.png": 1744,
	"./gameboy.png": 6260,
	"./hamish.png": 5874,
	"./headphones.png": 7345,
	"./iron.png": 3014,
	"./kids-bike.png": 9080,
	"./kitchen-sink.png": 9357,
	"./kite.png": 8353,
	"./lamp.png": 3459,
	"./luggage.png": 1716,
	"./microwave.png": 1871,
	"./moses-basket.png": 7542,
	"./mug.png": 4439,
	"./picnic-basket.png": 8698,
	"./pizza-oven.png": 3697,
	"./plants.png": 867,
	"./pop.png": 4991,
	"./pram.png": 5898,
	"./radio.png": 2631,
	"./rubber-ring.png": 7190,
	"./rubix-cube.png": 1801,
	"./rucksack.png": 9017,
	"./scooter.png": 3499,
	"./skateboard.png": 5182,
	"./sleeping-bag.png": 9007,
	"./socks.png": 8867,
	"./suitcase.png": 17,
	"./sunglasses.png": 3566,
	"./supersoaker.png": 3621,
	"./surfboard.png": 4896,
	"./table.png": 6656,
	"./tape-measure.png": 9260,
	"./tennis-ball.png": 833,
	"./tent.png": 3567,
	"./toothbrush.png": 3888,
	"./umbrella.png": 877,
	"./walking-boot.png": 9514,
	"./water-bottle.png": 2895,
	"./welly.png": 2951,
	"./windbreak.png": 7606,
	"./wine-box.png": 4951
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5133;